import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../shared/services/auth.service';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  cnpInputType = 'password';
  newpInputType = 'password';
  currpInputType = 'password';

  bbxuserID = sessionStorage.getItem('bbx-userID');
  constructor(
    private formBuilder: FormBuilder,
    private errorDialogService: ErrorDialogService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.changePasswordForm = this.formBuilder.group({
      userID: new FormControl({ value: this.bbxuserID, disabled: true }, Validators.required),
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
  }

  changePswd() {
    const reqobj = this.changePasswordForm.value;
    delete reqobj['confirmPassword'];
    this.authService.changePassword(this.changePasswordForm.value).subscribe(() => {
      this.router.navigateByUrl('/shipment-list');
      this.errorDialogService.openDialog('alert.passwordChanged', false);
    });
  }

  showCurrPwd(event: any) {
    event.target.checked ? (this.currpInputType = 'text') : (this.currpInputType = 'password');
  }
}
